// extracted by mini-css-extract-plugin
export default {"companyContainer":"GQ-z","companyImage":"HQ-z","container":"IQ-z","heading":"JQ-z","darkText":"KQ-z","smallHeading":"LQ-z","darkBackground":"MQ-z","whiteBackground":"NQ-z"};